module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Reply-all-fa23f8924c7a65573ac14e9d6f2d4677.svg";